



































































































import { requiredRule } from "@/lib/rules/requiredRule";
import { ThgThgViewModelGen } from "@/services/thg/v1/data-contracts";
import { Component, Prop, Vue } from "vue-property-decorator";
import Debug from "../utility/Debug.vue";

@Component({
  components: { Debug }
})
export default class ThgAdminUpdatePayoutConfigurationDialog extends Vue {
  @Prop()
  thg!: ThgThgViewModelGen;

  /**
   * Displays loading animation
   */
  @Prop({ default: false })
  loading!: boolean;

  /**
   * Form valid
   */
  isValid = false;

  /**
   * Show Dialog
   */
  isDialogActive = false;

  openDialog() {
    this.isDialogActive = true;
  }

  get requiredRule() {
    return requiredRule();
  }

  async save(): Promise<ThgThgViewModelGen> {
    this.isDialogActive = false;

    this.$emit("save", this.thg);
    this.close();

    return this.thg;
  }

  async close() {
    this.isDialogActive = false;
    this.$emit("refresh");
  }
}
